<app-uni-dialog  [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <form #form>
    <div class="mt-3">
      <label class="mr-2" for="doc_file">{{params.label}}</label>
      <input type="file" id="doc_file" #doc_file name="doc_file" (change)="setDocFile($event)" class="form-control" style="width: 500px;"/>
    </div>
  </form>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button [disabled]="docFile == null" (click)="ok()"
      pButton type="button" class="p-button-raised">
      Ok 
    </button>
    <button (click)="cancel()"
      pButton type="button" class="p-button-raised">
      Cancel 
    </button>
  </div>
</ng-template>
